import { render } from "./icon-arrow.vue?vue&type=template&id=7ee11e2c"
import script from "./icon-arrow.vue?vue&type=script&lang=js"
export * from "./icon-arrow.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__